import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';

const getClump = (hasText) => {
    if (hasText) {
        return '-webkit-line-clamp: 2;';
    }
};
const getTextHeightAndClump = (hasActions, hasTitle, isTitleLong) => {
    if (hasActions) {
        if (!hasTitle) {
            return 'max-height: 68px; -webkit-line-clamp: 4;';
        }
        return `-webkit-line-clamp: ${isTitleLong ? 2 : 3} ;`;
    }
    return '-webkit-line-clamp: 4;';
};
const TextWrapper = styled(MuiBox) `
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 4)};
  justify-content: center;
  overflow-wrap: break-word;
  ${({ hasActions }) => hasActions && 'max-height: 100px;'};
`;
const Title = styled(MuiTypography, {
    shouldForwardProp: prop => !['hasText', 'hasIcon'].includes(prop),
}) `
  margin: ${({ theme, hasText }) => (hasText ? theme.spacing(0, 0, 1, 0) : 0)};
  color: ${({ theme }) => theme.palette.N20.main};
  max-width: ${({ hasIcon }) => (hasIcon ? '200px' : '230px')};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 1.5;
  max-height: 32px;
  ${({ hasText }) => getClump(hasText)};
`;
const props = ['hasIcon', 'hasActions', 'hasTitle', 'isTitleLong', 'hasCloseButton', 'hasActions'];
const Text = styled(MuiTypography, {
    shouldForwardProp: prop => !props.includes(prop),
}) `
  color: ${({ theme }) => theme.palette.N10.main};
  max-width: ${({ hasIcon }) => (hasIcon ? '220px' : '252px')};
  overflow: hidden;
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 1.3;
  padding: ${({ theme, hasCloseButton }) => (hasCloseButton ? theme.spacing(0, 5.5, 0, 0) : 0)};
  ${({ hasActions, hasTitle, isTitleLong }) => getTextHeightAndClump(hasActions, hasTitle, isTitleLong)};
`;
const ToastInfo = ({ title, text, children, hasIcon, hasActions, hasCloseButton }) => {
    const [isTitleLong, setIsTitleLong] = useState(false);
    const handleTitleSizeChange = useCallback(ref => {
        if (ref) {
            setIsTitleLong(ref.clientHeight > 22);
        }
    }, []);
    return (jsxs(TextWrapper, Object.assign({ hasActions: hasActions }, { children: [title && (jsx(Title, Object.assign({ hasText: !!text, hasIcon: hasIcon, ref: handleTitleSizeChange, variant: "subtitle1" }, { children: title }))), text && (jsx(Text, Object.assign({ hasTitle: !!title, hasIcon: hasIcon, hasActions: hasActions, hasCloseButton: hasCloseButton, isTitleLong: isTitleLong, variant: "body1" }, { children: text }))), children] })));
};

export { ToastInfo as default };
//# sourceMappingURL=ToastInfo.js.map
